import { createFileRoute } from '@tanstack/react-router';

/** Route stub; map UI is loaded via map.lazy.tsx (Phase 5 migration complete — no LD guard). */
export const Route = createFileRoute('/$org/$agent/map')({});
